// src/features/dashboard/utils/timeAllocationChart.utils.tsx

import React from 'react';

import { Sector } from 'recharts';

/**
 * Render Pie Label
 */
export const renderLabel = (
  props: any,
) => {

  const RADIAN = Math.PI / 180;

  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    percent,
    midAngle,
  } = props;

  const radius =
    innerRadius +
    (outerRadius - innerRadius) * 0.55;

  const x =
    cx +
    radius *
      Math.cos(-midAngle * RADIAN);

  const y =
    cy +
    radius *
      Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill='#FFFFFF'
      textAnchor='middle'
      dominantBaseline='central'
      fontSize={11}
      fontWeight={700}
    >
      {(percent * 100).toFixed(1)}%
    </text>
  );
};

/**
 * Render Active Shape
 */
export const renderActiveShape = (
  props: any,
) => {

  const RADIAN = Math.PI / 180;

  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    percent,
    midAngle,
  } = props;

  const radius =
    innerRadius +
    (outerRadius - innerRadius) * 0.55;

  const x =
    cx +
    radius *
      Math.cos(-midAngle * RADIAN);

  const y =
    cy +
    radius *
      Math.sin(-midAngle * RADIAN);

  return (
    <g>

      {/* Active Slice */}
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 3}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />

      {/* Percentage */}
      <text
        x={x}
        y={y}
        fill='#FFFFFF'
        textAnchor='middle'
        dominantBaseline='central'
        fontSize={11}
        fontWeight={700}
      >
        {(percent * 100).toFixed(1)}%
      </text>

    </g>
  );
};